import React from 'react';

// Styles & Assets
import styles from './PreconfigPathologies.module.css';
import { PreconfigPathology } from '../../../interfaces/Preconfigurations';

// Interfaces
interface Props {
    preconfigPathologies: PreconfigPathology[]
}

const PreconfigPathologies: React.FC<Props> = ({ preconfigPathologies }) => {

    return (
        <div className={styles.pathologiesContainer}>
            {preconfigPathologies.map(p =>
                <div key={p.pathology_id} className={styles.pathologyItem}>
                    {p.pathology?.name ?? ''}
                </div>
            )}
        </div>
    );
};

export default PreconfigPathologies;